module.exports = __webpack_public_path__ + "img/stopwatch-20-solid.c1780592.svg";